import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type { GetPreferenceResponse } from '../types';

type ApiEnvelope<T> = { data: T };

export const getPreference = async <T extends Record<string, unknown>>(params: {
  boardId: number;
  key: string;
}): Promise<GetPreferenceResponse<T>> => {
  const { boardId, key } = params;
  const url = `/api/v2/boards/${boardId}/preferences/${encodeURIComponent(key)}`;

  const { data } =
    await apiAuthClient.get<ApiEnvelope<GetPreferenceResponse<T>>>(url);
  return data.data;
};
